// super simple pluralize
export default function pluralize (value, word) {
  return word + (Math.abs(value) === 1 ? '' : 's');
}
